// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"112":"8ddc9688","191":"4855356a"}[chunkId] + ".js";
};